// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"65d3be74","119":"4660c679","170":"23db809d","299":"a871eaef","469":"97440010","483":"94c300be","543":"1a33a9b2","588":"063a6098","656":"dce2a0cd","686":"d8f06dbf","699":"d2622fa1","719":"28e6efba","890":"7e8628e2","892":"5868b259","936":"8acc2df8"}[chunkId] + ".chunk.js";
};